import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { colors, fontWeights } from '@/styles'

const DropdownComponentWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`

const DropdownColorScheme = styled.span`
  display: inline-block;
  width: 8px;
  height: 58px;
  margin-right: 8px;
  border-radius: 2px;
  background: ${props => props.color};
  flex-shrink: 0;
`

const NameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 190px;
`

const DropdownName = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 16px;
  font-weight: ${fontWeights.medium};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

const DropdownEmail = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 16px;
  font-weight: ${fontWeights.regular};
  color: ${colors.grey56};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`
const CounterTextWrapper = styled.div`
  color: #525252;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  padding-top: 8px;
`

const DropdownComponent = ({ color, name, email, itemCount }) => {
  const { t } = useTranslation()
  const items = itemCount ? itemCount : 0
  return (
    <DropdownComponentWrapper>
      <ContentWrapper>
        <DropdownColorScheme color={color} />
        <NameWrapper>
          <DropdownName>{name}</DropdownName>
          {email && <DropdownEmail>{email}</DropdownEmail>}

          <CounterTextWrapper>
            {items}{' '}
            {items === 1
              ? t(
                  'l.contract_edit.document_widget.singular_recipients.counter',
                  'field to complete'
                )
              : t('l.contract_edit.document_widget.recipients.counter', 'fields to complete')}
          </CounterTextWrapper>
        </NameWrapper>
      </ContentWrapper>
    </DropdownComponentWrapper>
  )
}

export default DropdownComponent
